import React from "react";
import { IntlShape, Consumer } from "./Context";

type WithIntlProps<P> = Omit<P, keyof IntlShape>;

export default function withIntl(WrappedComponent: React.ComponentType<any>): React.FC<WithIntlProps<any>> {
    return (props: any) => <Consumer>{(intl) => <WrappedComponent {...props} intl={intl} />}</Consumer>;
}
